import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GamePlanService } from 'src/app/_clusters/services/game-plan.service';
import { LoginService } from 'src/app/_clusters/services/login.service';

@Component({
  selector: 'app-on-boarding-loader',
  templateUrl: './on-boarding-loader.component.html',
  styleUrls: ['./on-boarding-loader.component.scss']
})
export class OnBoardingLoaderComponent implements OnInit {
  userData: any = {}
  constructor(private loginService: LoginService, private router: Router, private gamePlanService: GamePlanService) { }

  ngOnInit(): void { window.scroll({top:0,left:0,behavior:"smooth"});
    this.getUserDetails()
    setTimeout(() => {

      this.loginService.updateWelcomeStatus({ isWelcome: 6 }).subscribe()

      this.router.navigateByUrl('/lms/launchpad');

    }, 5000);
  }

  async getUserDetails() {
    await this.gamePlanService.updateUserPrioritizeSubject().subscribe()
    await this.gamePlanService.getStudentTotalDetails().subscribe((res: any) => {
      if (res && res.status) {
        this.userData = res.data[0]

        localStorage.setItem('subjectId', this.userData.prioritize_subject);
      }

    })

  }

}
